import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseTemplate } from "../../../../../../shared/baseTemplate";
import { CongratulationComponent } from "../../../../../../shared/components/congratulation/congratulation.component";
import { AuthService } from "../../../../../../shared/services/auth.service";
import { CurrencyExchangeService } from "../../../../../../shared/services/currency-exchange.service";
import { GetBusinessProfileService } from "../../../../../../shared/services/get-business-profile.service";
import { Invoice } from "../../../../buyer";
import { GetCalculatesParamsService } from "../../../../services/get-calculates-params.service";
import { PaymentOptionsService } from "../../../../services/payment-options.service";
import { ViewProductInfoHandlerService } from "../../../../services/view-product-info-handler.service";
import { Meta, Title } from "@angular/platform-browser";

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent extends BaseTemplate
  implements OnInit, AfterViewInit {
  expiryDate: any;
  description: any;
  invoiceItems: Invoice[] = [];
  taxes: number = 0;
  fees: number = 0;
  total: number = 0;
  subTotal: number = 0;
  ifTaxesPercentage: boolean = false;
  ifFeesPercentage: boolean = false;
  invoiceName: string = '';
  invoiceNumber: number = 0;
  issuanceDate!: Date;
  businessLogo: string = "";
  businessName: string = "";
  url = window.location.href;
  @Input() productObject: any;
  businessObject: any;

  constructor(
    private Dialog: MatDialog,
    vpihs: ViewProductInfoHandlerService,
    getBusinessProfileService: GetBusinessProfileService,
    auth: AuthService,
    public exchangeService: CurrencyExchangeService,
    private paymentOptionsService: PaymentOptionsService,
    public getCalculatesParamsService: GetCalculatesParamsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta
  ) {
    super(vpihs, getBusinessProfileService, auth, exchangeService, getCalculatesParamsService);
  }

  async openShareButtonsDialog() {
    const dialogRef = this.Dialog.open(CongratulationComponent, {
      panelClass: "responsive-dialog",
      data: {
        url: this.url,
        name: this.productObject.productName || "",
        type: "Invoice",
        showCongratulation: false,
        showButton: false
      }
    });
  }

  async ngOnInit() {
    this.businessObject = this.productObject.Business;
    let paymentOptions = await this.paymentOptionsService.make();
    let selectedPaymentId = JSON.parse(this.productObject['paymentOptions'])
    /*console.log(`product`, this.productObject);*/
    await this.initCurrencies();

    this.issuanceDate = this.productObject.createdAt;

    if (this.businessObject.logo) {
      this.businessLogo = this.businessObject.logo;
    }
    this.businessName = this.businessObject.name;
    this.expiryDate = this.productObject.expiryDate;
    this.description = this.getNewProductValueByFieldName("description", "ProductExtraInfos");
    const items = this.productObject.InvoiceItems || [];
    // set default quantity
    this.vpihs.quantity = 1;
    this.quantity = 1;

    const currency = this.getNewProductValueByFieldName("currency", "ProductExtraInfos");

    for (const item of items) {
      this.invoiceItems.push({
        Item_Name: item.name,
        Price: item.price,
        Quantity: item.quantity
      });
    }
    this.invoiceName = this.productObject.productName || "";
    this.invoiceNumber = this.productObject['InvoiceProductExtraInfo'].invoiceNumber;
    const taxesObj = this.productObject.ProductTax;
    if (taxesObj) {
      this.taxes = taxesObj.taxes || 0;
      const taxesType = taxesObj.type;
      if (taxesType) {
        if (taxesObj.type === "Percentage") {
          this.ifTaxesPercentage = true;
        }
      }
    }
    this.commitChanges();
  }

  calculateSubTotalAmount() {
    let stotal = 0;
    for (const item of this.invoiceItems) {
      stotal += item.Price * item.Quantity;
    }

    return (this.vpihs.subTotal = this.subTotal = this.vpihs.getExchangedValue(
      stotal,
      this.getNewProductValueByFieldName("currency", "ProductExtraInfos")
    ));
  }

  getFeesFromSeller() {
    const feesStringValue = this.getNewProductValueByFieldName('feesOnBuyerFlag', 'ProductExtraInfos');
    let netFees = 0;
    if (feesStringValue === "true" || feesStringValue === "1") {
      const feesValue = this.businessObject.fees;
      const feesType = this.businessObject.fees_type;
      if (feesType === "Percentage") {
        let amount = 0;
        for (const item of this.invoiceItems) {
          amount += item.Price * item.Quantity;
        }
        if (this.dicountValue < -0) {
          let discount;
          if (this.vpihs.currency != 'EGP') {
            discount = +(this.dicountValue * this.getExchangeRateToEGP(this.vpihs.currency)) || 0;
          }
          else {
            discount = +this.dicountValue || 0;
          }
          netFees = ((amount - Math.abs(discount)) + this.vpihs.taxes) * (Number(feesValue) / 100);
        }
        else {
          netFees = ((amount + this.vpihs.taxes) * Number(feesValue)) / 100;
        }
        console.log("netFees", netFees)
      } else {
        netFees = feesValue;
      }
      const feesObject = {
        name: "Buyer Fees",
        value: this.vpihs.getExchangedValue(netFees, this.vpihs.currency)
      };
      return feesObject;
    } else {
      return null;
    }
  }

  animationEvent(type: string) {
    let infoBar = document.getElementById('info-bar');
    let productCoverTag = document.getElementById('product-cover-tag');
    if (infoBar && productCoverTag) {
      if (type == 'in') {
        productCoverTag.style.opacity = '.2';
        infoBar.style.marginTop = '2rem';
      } else if (type == 'out') {
        productCoverTag.style.opacity = '1';
        infoBar.style.marginTop = '-6rem';
      };
    }
  }

  proceedToPayment() {
    this.commitChanges();
    this.router.navigate(["buyerinfo"], { relativeTo: this.activatedRoute });
  }
}
